<template>

    <PreloaderIcon v-show="!visible" />

    <FadeInTransition>
        <img
            v-show="visible"
            :src="src"
            :alt="alt"
            :class="props.classes"
            width=""
            height=""
        />
    </FadeInTransition>
</template>

<script setup lang="ts">
    import { MediaElements } from "~/composables/Classes/Media";

    const props = withDefaults(
        defineProps<{
            src: string
            alt?: string,
            classes?: any
        }>(),
        {
            alt: 'Walbert-Schmitz Image'
        }
    )

    const emit = defineEmits(['loaded'])

    const visible = ref<boolean>(false)
    const cachedImageSrc = ref<any>()

    const onImageLoad = () => {
        // Set a timeout to delay hiding the Skeleton Loader
        setTimeout(() => {
            visible.value = true;
            emit('loaded')
        }, 400); // Adjust the timing as needed
    };

    const renderMedia = () => {
        let render = new MediaElements(props.src, (visible.value = false));

        render.setImage()
            .then((successUrl) => {
                cachedImageSrc.value = successUrl;
                onImageLoad();
            })
            .catch((error) => {
                console.error(error);
            });
        };

    renderMedia()
</script>